export default {
    SESSION_EXPIRED: 600,
    APPLICATION_ERROR: 101
};
